export const PRODUCT_VERSION = "2.7.0";
export const PRODUCT_RELEASE = "Alpha 2.7.0";
